"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var inject_typesafe_1 = require("inject-typesafe");
var account_1 = require("../api/account");
var apifetch_json_1 = require("apifetch-json");
var cacheInRedux_1 = require("../shared/cacheInRedux");
/**
 * Returns a configured service provider.
 */
function createServiceProvider(reduxStore) {
    return new inject_typesafe_1.ServiceProvider(function (builder) { return ({
        accountService: builder.singleton(function (services) { return new account_1.AccountService(); }),
        apiFetch: builder.singleton(function (services) { return new apifetch_json_1.ApiFetch(); }),
        cacheService: builder.singleton(function (services) { return new cacheInRedux_1.CacheService(function () { return services.reduxStore().getState().cache; }, services.reduxStore().dispatch); }),
        reduxStore: builder.singleton(function () { return reduxStore; }),
    }); });
}
exports.createServiceProvider = createServiceProvider;
//# sourceMappingURL=configureServices.js.map